import type { KeyValueStorage } from "@bundle/core";
import { STORAGE_NAMESPACE } from "./env.ts";

/** localStorage-backed KeyValueStorage (namespaced per mode; tolerant of private-mode failures). */
export function createStorage(namespace: string = STORAGE_NAMESPACE): KeyValueStorage {
  const k = (key: string) => `${namespace}:${key}`;
  return {
    get(key) {
      try {
        return localStorage.getItem(k(key)) ?? undefined;
      } catch {
        return undefined;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(k(key), value);
      } catch {
        // Quota or privacy mode: preferences are best-effort.
      }
    },
    remove(key) {
      try {
        localStorage.removeItem(k(key));
      } catch {
        // ignore
      }
    },
  };
}
